import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useIntercom } from './IntercomProvider';

/**
 * Help button that opens Intercom messenger
 * Place this next to the notification bell in the dashboard header
 */
export function HelpButton() {
  const { show } = useIntercom();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            id="intercom-help-button"
            variant="ghost"
            size="icon"
            onClick={show}
            className="relative"
          >
            <HelpCircle className="h-5 w-5 text-muted-foreground" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Get help</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

